import { createApi } from '@reduxjs/toolkit/query/react';
import { BackendResponse, ITableFilters } from '../../types';
import { parseQueryParams } from '../../utils';
import { SystemModule } from '../../enums';
import {
  IApprovalLogQueryParams,
  IApprovalLogTable,
} from '../../pages/Requisitions/constants/requisition.interface';
import { IProcessChangeLogTable } from '../../types/process';
import { baseQueryWithReauth } from './baseQuery';

const processApi = createApi({
  reducerPath: 'process',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['UserApprovalActions', 'ChangeLogs'],
  endpoints: builder => ({
    getProcessApprovalActions: builder.query<
      BackendResponse<boolean>,
      { id: number; module: SystemModule }
    >({
      query: params => {
        return {
          url: `/process/approvals/actions${parseQueryParams(params)}`,
          method: 'GET',
        };
      },
      providesTags: (__, error, { module, id }) => {
        if (error) {
          return [];
        }
        return [{ type: 'UserApprovalActions', id: `${module}_${id}` }];
      },
    }),
    updateProcessApproval: builder.mutation<BackendResponse<void>, any>({
      query: ({ id, ...payload }) => ({
        url: `/process/approvals/action/${id}`,
        method: 'POST',
        body: {
          ...payload,
        },
      }),
      invalidatesTags: (_, error, { id, module }) => {
        if (error) {
          return [];
        }
        return [{ type: 'UserApprovalActions', id: `${module}_${id}` }];
      },
    }),
    getProcessApprovalLogs: builder.query<
      BackendResponse<{ list: IApprovalLogTable[]; count?: number }>,
      IApprovalLogQueryParams
    >({
      query: params => ({
        url: `/process/approvals/logs${parseQueryParams(params)}`,
        method: 'GET',
      }),
      providesTags: (__, error, { module, id }) => {
        if (error) {
          return [];
        }
        return [{ type: 'UserApprovalActions', id: `${module}_${id}` }];
      },
    }),
    processLogsById: builder.query<
      BackendResponse<{ list: IProcessChangeLogTable[]; count: number }>,
      { id: string | number; filters: ITableFilters }
    >({
      query: ({ filters, id }) => {
        const query = parseQueryParams(filters);
        return {
          url: `/process/logs/${id}${query}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const {
  useGetProcessApprovalActionsQuery,
  useLazyGetProcessApprovalActionsQuery,
  useUpdateProcessApprovalMutation,
  useGetProcessApprovalLogsQuery,
  useProcessLogsByIdQuery,
} = processApi;

export default processApi;
